import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  addProgramWrapper: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
  },
  addProgramForm: {
    width: '100%',
    '& li.scopeItem': {
      maxWidth: 'unset',
    },
  },
  addProgramButtonWrapper: {
    padding: `${theme.spacing(1)} 0`,
  },
  uploadFileButton: {
    height: theme.spacing(4),
    lineHeight: theme.spacing(3),
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    display: 'inline-flex',
    marginBottom: theme.spacing(1),
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
  avatarWrapper: {
    paddingBottom: theme.spacing(1),
    '& img': {
      maxWidth: 100,
      maxHeight: 100,
    },
  },
  title: {
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    fontWeight: 500,
    fontStyle: 'normal',
    color: theme.palette.grey[600],
    paddingBottom: theme.spacing(1),
  },
}));
